import { CustomProjectPropertyValueResponse } from "../../api-models/response/CustomProjectPropertyValueResponse";
import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { ProjectResponse } from "../../api-models/response/project/ProjectResponse";
import { ProjectCodeSystemResponse } from "../../api-models/response/ProjectCodeSystemResponse";
import { ProjectFormatResponse } from "../../api-models/response/ProjectFormatResponse";
import { RowItemData } from "../../components/datatable/interfaces";
import { emptyProjectCodeSystem, emptyProjectFormat } from "./ProjectFormatCodeSystemService";
import dateService from "../date-service/DateService";
import { CoordinateSystem, emptyCoordinateSystem } from "../organization/GisCoordinates";
import { translationService } from "../translation/TranslationService";
import { ProjectStatus } from "../../generated/Projects";

export class Project implements RowItemData {
  id: number;
  name: string;
  status: number;
  lead: NameEntityResponse;
  format: ProjectFormatResponse;
  codeSystem: ProjectCodeSystemResponse;
  availableFrom: Date;
  deadline: Date;
  description: string;
  sewerObjectsCount: number;
  jobsCount: number;
  membersCount: number;
  created: Date;
  createdBy: NameEntityResponse;
  modified: Date;
  gisCoordinates: CoordinateSystem;
  reportTemplate: NameEntityResponse;
  customPropertyValues: CustomProjectPropertyValueResponse[];
  lastCompared: Date;
  comparisonInProgress: boolean;

  constructor(projectResponse: ProjectResponse) {
    this.id = projectResponse.id;
    this.name = projectResponse.name;
    this.status = projectResponse.status;
    this.availableFrom = projectResponse.availableFrom;
    this.deadline = projectResponse.deadline;
    this.created = projectResponse.created;
    this.createdBy = projectResponse.createdBy;
    this.modified = projectResponse.modified;
    this.lead = projectResponse.lead;
    this.format = projectResponse.format || emptyProjectFormat;
    this.codeSystem = projectResponse.codeSystem || emptyProjectCodeSystem;
    this.sewerObjectsCount = projectResponse.sewerObjectsCount;
    this.jobsCount = projectResponse.jobsCount;
    this.membersCount = projectResponse.membersCount;
    this.description = projectResponse.description;
    this.gisCoordinates = projectResponse.gisCoordinates
      ? {
          id: projectResponse.gisCoordinates.id,
          name: projectResponse.gisCoordinates.name,
          wkid: projectResponse.gisCoordinates.wkid,
          description: {
            areaOfUse: projectResponse.gisCoordinates.areaOfUse,
            minimumLatitude: projectResponse.gisCoordinates.minLatitude,
            maximumLatitude: projectResponse.gisCoordinates.maxLatitude,
            minimumLongitude: projectResponse.gisCoordinates.minLongitude,
            maximumLongitude: projectResponse.gisCoordinates.maxLongitude,
          },
        }
      : emptyCoordinateSystem;
    this.reportTemplate = projectResponse.reportTemplate;
    this.customPropertyValues = projectResponse.customProjectPropertyValues || [];
    this.lastCompared = projectResponse.lastCompared;
    this.comparisonInProgress = projectResponse.comparisonInProgress;
  }

  get displayValues() {
    return {
      name: { toDisplay: this.name },
      status: { toDisplay: this.getDisplayStatus() },
      deadline: { toDisplay: this.getFormatedDeadline() },
      lead: { toDisplay: this.getLeadName() },
      format: { toDisplay: this.getFormatName() },
      codeSystem: { toDisplay: this.getCodeSystemName() },
      sewerObjectsCount: { toDisplay: this.sewerObjectsCount },
      jobsCount: { toDisplay: this.jobsCount },
      membersCount: { toDisplay: this.membersCount },
      modified: { toDisplay: this.getModified() },
    };
  }

  private getDisplayStatus(): any {
    return translationService.translate(`general.projects.status.${ProjectStatus[this.status]}`);
  }
  private getFormatedDeadline(): string | null {
    return this.deadline ? dateService.formatDate(this.deadline) : null;
  }
  private getLeadName(): string | null {
    return this.lead && this.lead.name;
  }

  getCodeSystemName() {
    return this.codeSystem && this.codeSystem.name;
  }
  getFormatName() {
    return this.format && this.format.name;
  }
  private getModified(): string {
    return dateService.formatDate(this.modified);
  }
}
